module.exports = __webpack_public_path__ + "media/images/home/security-2-d7d88f66cbe7ca6b331feb997fb6f885.jpg";